import { createApi } from '@reduxjs/toolkit/query/react';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import { CmsDimension, CmsDimensionsResponse } from './cmsDimensions.types';

type CmsDimensionResponse = {
  dimension?: CmsDimension | null;
};

const cmsDimensionsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms',
  }),
  reducerPath: 'cmsDimensions',
  tagTypes: ['CmsDimensions'],
  endpoints: (build) => ({
    getCmsDimension: build.query<CmsDimension | null, { slug: string }>({
      query: ({ slug }) => ({
        url: `/dimension/${slug}`,
        method: 'GET',
      }),
      transformResponse: (response: CmsDimensionResponse) =>
        response.dimension ?? null,
    }),
    getCmsDimensions: build.query<CmsDimension[], void>({
      query: () => ({
        url: '/dimensions',
        method: 'GET',
      }),
      transformResponse: (response: CmsDimensionsResponse) =>
        response.dimensions ?? [],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data: dimensions } = await queryFulfilled;

          for (const dimension of dimensions) {
            dispatch(
              cmsDimensionsApi.util.upsertQueryData(
                'getCmsDimension',
                { slug: dimension.slug },
                dimension,
              ),
            );
          }
        } catch {
          // Ignore cache sync when list request fails.
        }
      },
    }),
  }),
});

export default cmsDimensionsApi;
